import React from 'react';

export const Clear = () => (
  <g
    transform="matrix(67.499974,0,0,67.499974,-3.4662499e-6,4.1946625e-4)"
    strokeWidth="0.01481482"
  >
    <path
      d="M 12,10.869 10.869,12 8,9.125 5.126,12 4,10.869 6.87,8 4,5.126 5.126,4 8,6.87 10.869,4 12,5.126 9.125,8 Z M 8,0 A 8,8 0 1 0 16,8 7.99,7.99 0 0 0 8,0 Z"
      fill="#c2ccd8"
      strokeWidth="0.01481482"
    />
  </g>
);
